import 'shared/global';
import 'components/subnav';
import textSizesSwitcher from 'shows/textSizesSwitcher';

textSizesSwitcher({
    target: '#js-about-copy'
});

let items = null;
document.addEventListener('DOMContentLoaded', () => {
    items = document.querySelectorAll('.text__sizes_switcher button.control__item');
    const controller = document.getElementById('text__sizes_controller');
    if (!controller) {
        console.log('Text size switcher handler failed to load.');
        return;
    }
    if (items && Array.from(items)) {
        items.forEach((elem) => {
            elem.addEventListener('click', async () => {
                controller.setAttribute('aria-activedescendant', elem.id);
                await resetAriaChecked();
                elem.setAttribute('aria-checked', 'true');
            });
        });
    }
});
async function resetAriaChecked() {
    await items.forEach((elem) => {
        elem.setAttribute('aria-checked', 'false');
    });
}
